import type dayjs from 'dayjs';
import type { AccountList } from 'src/types/user';
import type { Theme, SxProps, CSSObject } from '@mui/material/styles';

import { forwardRef } from 'react';

import { TableHeadView } from './table-head-view';
import { useTableHeadLogic } from '../../hooks/use-table-head-logic';

// ----------------------------------------------------------------------

export type TableHeadCellProps = {
  id: string;
  type?: string;
  label?: string;
  options?: { label: string; value: string }[];
  width?: CSSObject['width'];
  align?: 'left' | 'center' | 'right';
  sx?: SxProps<Theme>;
  filterable?: boolean;
  /** Text filter accepts digits only (e.g. a priority number). */
  numericFilter?: boolean;
  isDisable?: boolean;
};

export type TableHeadCustomProps = {
  orderBy?: string;
  rowCount?: number;
  sx?: SxProps<Theme>;
  numSelected?: number;
  order?: 'asc' | 'desc';
  headCells: TableHeadCellProps[];
  onSort?: (id: string) => void;
  onSelectAllRows?: (checked: boolean) => void;
  handleFilterChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    column: keyof AccountList
  ) => void;
  selectRowPremission?: boolean;
  sortFldList?: string[];
  isCampaignTamplate?: boolean;
  isEdit?: boolean;
  isDelete?: boolean;
  setDateTimeFilter?: any;
  isCampaining?: boolean;
  handleToggleSelectAll?: any;
  selectAllFilter?: any;
  count?: number;
  defaultBedgecondition?: boolean;
  selectedContact?: any;
  dateTimeFiltre: {
    id: string;
    fromDate: dayjs.Dayjs;
    toDate: dayjs.Dayjs;
  }[];
  setPage: any;
  moduleName?: string;
  resetFilterKey?: number;
  disableSelectAll?: boolean;
};

// ----------------------------------------------------------------------

export const TableHeadCustom = forwardRef<
  { handleRemoveAllFilter: () => void },
  TableHeadCustomProps
>((props, ref) => {
  const logic = useTableHeadLogic({
    headCells: props.headCells,
    dateTimeFiltre: props.dateTimeFiltre,
    moduleName: props.moduleName,
    resetFilterKey: props.resetFilterKey,
    handleFilterChange: props.handleFilterChange,
    setDateTimeFilter: props.setDateTimeFilter,
    setPage: props.setPage,
    ref,
  });

  return <TableHeadView {...props} {...logic} ref={ref} />;
});

TableHeadCustom.displayName = 'TableHeadCustom';
